import CloseIcon from "@mui/icons-material/Close";
import {
	Box,
	CircularProgress,
	Grid,
	IconButton,
	Link,
	Modal,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Typography,
} from "@mui/material";
import { format, parseISO } from "date-fns";
import { ISinisterCaseStatusEntry } from "../../../../shared/services/api/sinister/SinisterNegotiationService";
import { getCaseStatusLabel } from "../../constants/caseStatusOptions";

interface Props {
	open: boolean;
	entries: ISinisterCaseStatusEntry[];
	isLoading?: boolean;
	onClose: () => void;
}

export const ModalCaseStatusHistory = ({ open, entries, isLoading, onClose }: Props) => {
	return (
		<Modal open={open} onClose={onClose}>
			<Box
				sx={{
					position: "absolute",
					top: "50%",
					left: "50%",
					transform: "translate(-50%, -50%)",
					bgcolor: "background.paper",
					boxShadow: 24,
					p: 3,
					width: "90%",
					maxWidth: 800,
					maxHeight: "90vh",
					overflowY: "auto",
					borderRadius: 2,
				}}
			>
				<Grid container justifyContent="space-between" alignItems="center" mb={1}>
					<Typography variant="h6">Histórico de Status da Cobrança</Typography>
					<IconButton onClick={onClose} size="small">
						<CloseIcon />
					</IconButton>
				</Grid>

				{isLoading ? (
					<Box textAlign="center" py={4}>
						<CircularProgress size={28} />
					</Box>
				) : entries.length === 0 ? (
					<Typography variant="body2" color="text.secondary">
						Nenhuma mudança de status registrada ainda.
					</Typography>
				) : (
					<TableContainer>
						<Table size="small">
							<TableHead>
								<TableRow sx={{ backgroundColor: "grey.100" }}>
									<TableCell>Data</TableCell>
									<TableCell>Status</TableCell>
									<TableCell>Observação</TableCell>
									<TableCell>Anexo</TableCell>
									<TableCell>Operador</TableCell>
								</TableRow>
							</TableHead>
							<TableBody>
								{entries.map((entry) => (
									<TableRow key={entry.id} hover>
										<TableCell>{format(parseISO(entry.createdAt), "dd/MM/yyyy HH:mm")}</TableCell>
										<TableCell>{getCaseStatusLabel(entry.status)}</TableCell>
										<TableCell>{entry.note}</TableCell>
										<TableCell>
											{entry.attachmentUrl ? (
												<Link href={entry.attachmentUrl} target="_blank" rel="noopener noreferrer">
													Abrir anexo
												</Link>
											) : (
												"-"
											)}
										</TableCell>
										<TableCell>{entry.userName ?? "-"}</TableCell>
									</TableRow>
								))}
							</TableBody>
						</Table>
					</TableContainer>
				)}
			</Box>
		</Modal>
	);
};
